import { StyleSheet } from "react-native"

import { AppColors, AppFonts, Units } from "@theme"

export default StyleSheet.create({
  attachmentSender: {
    marginTop: Units.responsiveValue(10),
    marginLeft: Units.responsiveValue(10),
  },
  senderRow: {
    position: "absolute",
    top: -27,
    minWidth: Units.responsiveValue(145),
    flexDirection: "row",
    alignItems: "baseline",
  },
  messageSenderText: {
    color: AppColors.brand.coolGrey,
    ...AppFonts.smallishDemibold,
  },
  // CONV-PARITY 2026-07-03: quiet per-message time next to the sender name, matching
  // teeup-mobile's MessageTimestamp placed beside the name in the chat header row
  // (app/components/ui/chat/messageTimestamp) -- always visible, never swipe-gated.
  messageSenderTimestamp: {
    color: "#9AA2B1",
    ...AppFonts.smallestMedium,
    marginLeft: Units.responsiveValue(6),
  },
})
